export default __webpack_public_path__ + "static/media/SB_icon.88f439dd.svg";